var _ = require('underscore');
module.exports = function(options){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
__p+='';
  let { leadSubmitted, isLeadFormSuppressed, isLdpLeadsTextEnabled, isCoBroke, ctaButtonName,
          ab_flipped_cities_lead_form, isFlippedMarket, ctaText, ctaButtonNameEmail,
          property_type, ab_rearrange_experiement,
          name, new_community_name, hasSuppressLeadForm, isSpecHome } = options; 
__p+='\n\n';
  let leftButtonTitle ,emailTxtOverrideWidth; 
__p+='\n';
  let hlt_txt_vs_email_ab = MOVE_DATA.ab_hlt_text_vs_email 
__p+='\n';
  const SCHEDULE_TOUR_ENABLED = $('#schedule-tour-enabled').data('schedule-tour-enabled'); 
__p+='\n';
  let ab_display_ask_me_text = MOVE_DATA.ab_only_txt_mweb 
__p+='\n';
 if (hlt_txt_vs_email_ab==="V1") {
  leftButtonTitle  = "Email Agent";
  emailTxtOverrideWidth = true;
}
else if (hlt_txt_vs_email_ab==="V2") {
  leftButtonTitle  = "Email";
}

__p+='\n\n';
 let isNewPlan = property_type && property_type === 'new_plan'  
__p+='\n\n';
 if (isNewPlan || isSpecHome) { 
__p+='\n  ';
 ctaButtonName = 'Contact Builder' 
__p+='\n';
 } 
__p+='\n\n';
 let ab_email_icon_class_alt, email_button_default, ab_email_class; 
__p+='\n';
 if (MOVE.Helper.isMobile()) { 
__p+='\n  ';
 if (!leadSubmitted && !isNewPlan && !isSpecHome ) { 
__p+='\n    ';
 if (ab_rearrange_experiement) { 
__p+='\n      ';
 ab_email_class = "ab-icon-text-rearrange" 
__p+='\n    ';
 } else { 
__p+='\n      ';
 ab_email_class = "" 
__p+='\n    ';
 } 
__p+='  \n    ';
 ab_email_icon_class_alt = "ab-email-alt" 
__p+='\n    ';
 email_button_default = "" 
__p+='\n    ';
 ctaButtonName = "Email Agent" 
__p+='\n  ';
 } 
__p+='\n';
 } else { 
__p+='\n  ';
 ab_email_class = "" 
__p+='\n  ';
 ab_email_icon_class_alt = "" 
__p+='\n  ';
 email_button_default = "email-button-color" 
__p+='\n';
 } 
__p+='\n\n';
 let title = isNewPlan ? 'Tell me more about this plan' : 'Tell me more about this property' 
__p+='\n';
 const propertyText = name && name.toLowerCase().includes('plan') ? `${name}` : `${name} plan` 
__p+='\n';
 let placeholder = isNewPlan ? `I am interested in ${propertyText} in the ${new_community_name} community` : 'Request Details' 
__p+='\n\n';
 if (ab_flipped_cities_lead_form == "V1" && isFlippedMarket && isCoBroke) {
__p+='\n  <a href="javascript:void(0);" class="btn btn-primary lead-form-800 ';
 if (leadSubmitted) { 
__p+=' contacted ';
 } else { 
__p+=' js-qv-contact-agent ';
 } 
__p+='" ';
 if (!leadSubmitted) { 
__p+=' data-omtag="ldp:quickview:stickyfooter:contact-agent" data-formid="secondary" ';
 } 
__p+=' sticky-contact-agent>\n    ';
 if (leadSubmitted) { 
__p+=' Contacted ';
 } else { 
__p+=' Contact Agent ';
 } 
__p+='\n     </a>\n';
} else {
__p+='\n  ';
 if (isLdpLeadsTextEnabled && isCoBroke) { 
__p+='\n    ';
 if (ab_display_ask_me_text === "V1" && !isFlippedMarket) { 
__p+='\n      <div id="qv-footer-email-text-btn" class="qv-footer-email-text-btn hidden">\n        '+
((__t=( JST["quick_view/templates/optimization/qv-text-and-email-buttons"]({isLeadFormSuppressed, leadSubmitted, emailTxtOverrideWidth, leftButtonTitle}) ))==null?'':__t)+
'\n      </div>\n      <div class="qv-footer-question-btn">\n        <a href="javascript:void(0);" data-target="#textInputModal" data-toggle="modal" data-lead-position="qv-footer" class="js-hide-ajax-fail btn btn-primary ';
 if (!MOVE.Helper.isMobile()) { 
__p+=' round-cta ';
 } 
__p+=' email-button ';
 if (emailTxtOverrideWidth) { 
__p+=' email-text-buttons-equal ';
 } else { 
__p+=' ab-cta-v2';
 } 
__p+=' ab-ask-a-question-button js-text-leads" id="qv-sticky-text-cta" data-omtag="ldp:persistant-footer:text-agent" data-ab-only-text-cta-text-me="ab-only-text-cta-text-me"\n        data-ab-lead-submitted="';
 if (leadSubmitted) { 
__p+='yes';
 } else { 
__p+='no';
 }
__p+='">\n          Ask a question\n        </a>\n      </div>\n    ';
 } else { 
__p+='\n      ';
 if (hlt_txt_vs_email_ab==="V1" || hlt_txt_vs_email_ab==="V2") { 
__p+='\n        ';
 if (!isLeadFormSuppressed) { 
__p+='\n          <a href="javascript:void(0);" class="js-hide-ajax-fail ';
 if (leadSubmitted) { 
__p+=' contacted ';
 } else { 
__p+=' js-qv-contact-agent ';
 } 
__p+=' text-button  ';
 if (!MOVE.Helper.isMobile()) { 
__p+=' round-cta ';
 } 
__p+='  ';
 if (emailTxtOverrideWidth) { 
__p+=' email-text-buttons-equal ';
 } 
__p+=' email-button-left" ';
 if (!leadSubmitted) { 
__p+=' data-omtag="ldp:quickview:stickyfooter:contact-agent" data-formid="secondary" ';
 } 
__p+=' sticky-contact-agent>\n            ';
 if (leadSubmitted) { 
__p+=' Contacted ';
 } else { 
__p+=' '+
((__t=( leftButtonTitle ))==null?'':__t)+
'';
 } 
__p+='\n          </a>\n        ';
 } 
__p+='\n          ';
 if (isFlippedMarket && SCHEDULE_TOUR_ENABLED) { 
__p+='\n            <a href="javascript:void(0);" data-target="#scheduleTourModal" data-toggle="modal" class="js-hide-ajax-fail btn  ';
 if (!MOVE.Helper.isMobile()) { 
__p+=' round-cta ';
 } 
__p+=' email-button  ';
 if (emailTxtOverrideWidth) { 
__p+=' email-text-buttons-equal ';
 } else { 
__p+=' ab-cta-v2';
 } 
__p+='js-text-leads ot-schedule-tour" id="qv-sticky-st-cta" data-omtag="for_sale:ldp_quickview:sticky_footer:contact_agent_schedule_tour">Schedule Tour</a>\n          ';
 } else { 
__p+='\n            <a href="javascript:void(0);" data-target="#textInputModal" data-toggle="modal" data-lead-position="qv-footer" class="js-hide-ajax-fail btn  ';
 if (!MOVE.Helper.isMobile()) { 
__p+=' round-cta ';
 } 
__p+=' email-button ';
 if (emailTxtOverrideWidth) { 
__p+=' email-text-buttons-equal ';
 } else { 
__p+=' ab-cta-v2';
 } 
__p+='js-text-leads" id="app" data-omtag="ldp:persistant-footer:text-agent">Text</a>\n          ';
 } 
__p+='\n      ';
 } else {
__p+='\n          ';
 if (isFlippedMarket && SCHEDULE_TOUR_ENABLED) { 
__p+='\n            <a href="javascript:void(0);" data-target="#scheduleTourModal" data-toggle="modal" class="js-hide-ajax-fail btn ';
 if (!MOVE.Helper.isMobile()) { 
__p+=' round-cta ';
 } 
__p+=' email-button js-text-leads ot-schedule-tour tour-button-color" id="qv-sticky-st-cta" data-omtag="for_sale:ldp_quickview:sticky_footer:contact_agent_schedule_tour">Schedule Tour</a>\n            ';
 if ( MOVE.Helper.isMobile() && !isNewPlan) { 
__p+='\n              <a href="javascript:void(0);" id="qv-footer-email-tour" class="js-hide-ajax-fail email-button ab-email-tour ';
 if (leadSubmitted) { 
__p+=' contacted ';
 } else { 
__p+=' js-qv-contact-agent ';
 } 
__p+=' text-button  ';
 if (!MOVE.Helper.isMobile()) { 
__p+=' round-cta ';
 } 
__p+=' email-button-left';
 if (leadSubmitted) { 
__p+=' contacted-button-color email-button-color ';
 } else { 
__p+=' email-button-color';
 } 
__p+='" ';
 if (!leadSubmitted) { 
__p+=' data-omtag="ldp:quickview:stickyfooter:contact-agent" data-formid="secondary" ';
 } 
__p+=' sticky-contact-agent>\n                <div class="';
 if (!leadSubmitted) { 
__p+=' icon-tour-container ';
 } 
__p+='"><span class="';
 if (!leadSubmitted) { 
__p+=' ab-email-icon-tour ';
 } 
__p+='"></span><span class="';
 if (!leadSubmitted) { 
__p+=' ab-email-tour-words ';
 } 
__p+='">';
 if (leadSubmitted) { 
__p+=' Contacted ';
 } else { 
__p+=''+
((__t=( ctaButtonName ))==null?'':__t)+
'';
 } 
__p+='</span></div>\n              </a>\n            ';
 } else { 
__p+='\n              <a href="javascript:void(0);" class="js-hide-ajax-fail email-button ';
 if (leadSubmitted) { 
__p+=' contacted ';
 } else { 
__p+=' js-qv-contact-agent ';
 } 
__p+=' text-button  ';
 if (!MOVE.Helper.isMobile()) { 
__p+=' round-cta ';
 } 
__p+=' email-button-left';
 if (leadSubmitted) { 
__p+=' contacted-button-color email-button-color';
 } else { 
__p+=' email-button-color';
 } 
__p+='" ';
 if (!leadSubmitted) { 
__p+=' data-omtag="ldp:quickview:stickyfooter:contact-agent" data-formid="secondary" ';
 } 
__p+=' sticky-contact-agent>\n                ';
 if (leadSubmitted) { 
__p+=' Contacted ';
 } else { 
__p+=' Contact Agent';
 } 
__p+='\n              </a>\n            ';
 } 
__p+='\n          ';
 } else { 
__p+='\n            ';
 if (MOVE.Helper.isMobile()) { 
__p+='\n              ';
 if (hasSuppressLeadForm) { 
__p+='\n                <a href="javascript:void(0);" data-target="#textInputModal" data-toggle="modal" data-lead-position="qv-footer" class="js-hide-ajax-fail btn ab-text '+
((__t=( ab_email_class ))==null?'':__t)+
'';
 if (!MOVE.Helper.isMobile()) { 
__p+=' round-cta ';
 } 
__p+=' text-button ';
 if (emailTxtOverrideWidth) { 
__p+=' email-text-buttons-equal ';
 } 
__p+=' js-text-leads" id="qv-sticky-text-cta" data-omtag="ldp:persistant-footer:text-agent">\n                  <div id="text-icon-container"><div id="ab-text-i" class="ab-text-icon"><span class="';
 if (!leadSubmitted) { 
__p+=' ab-text-words ';
 } 
__p+='">Text</span></div></div>\n                </a>\n              ';
 } else { 
__p+='\n               <a href="javascript:void(0);" data-target="#textInputModal" data-toggle="modal" data-lead-position="qv-footer" class="btn suppress-lead-form-text" id="qv-sticky-text-cta" data-omtag="ldp:persistant-footer:text-agent">Text</a>\n              ';
 } 
__p+='\n            ';
 } else { 
__p+=' \n              <a href="javascript:void(0);" data-target="#textInputModal" data-toggle="modal" data-lead-position="qv-footer" class="js-hide-ajax-fail btn ';
 if (!MOVE.Helper.isMobile()) { 
__p+=' round-cta ';
 } 
__p+=' text-button ';
 if (emailTxtOverrideWidth) { 
__p+=' email-text-buttons-equal ';
 } 
__p+=' js-text-leads" id="qv-sticky-text-cta" data-omtag="ldp:persistant-footer:text-agent">Text</a>\n            ';
 } 
__p+='  \n          ';
 } 
__p+='\n        ';
 if (!isLeadFormSuppressed && !isFlippedMarket) { 
__p+='\n          ';
 if (MOVE.Helper.isMobile()) { 
__p+='\n            ';
 if (hasSuppressLeadForm) { 
__p+='\n              <a href="javascript:void(0);" id="qv-footer-email" class="js-hide-ajax-fail ';
 if (!MOVE.Helper.isMobile()) { 
__p+=' round-cta ';
 } 
__p+=' email-button ';
 if (leadSubmitted) { 
__p+=' contacted ';
 } else { 
__p+=' js-qv-contact-agent ';
 } 
__p+='" ';
 if (!leadSubmitted) { 
__p+=' data-omtag="ldp:quickview:stickyfooter:contact-agent" data-formid="secondary" ';
 } 
__p+=' sticky-contact-agent>\n                <div class="icon-container"><span class="';
 if (!leadSubmitted && !isNewPlan) { 
__p+=' email-icon-mobile ';
 } 
__p+='"></span><span class="';
 if (!leadSubmitted) { 
__p+=' ab-email-words ';
 } 
__p+='">';
 if (leadSubmitted) { 
__p+=' Contacted ';
 } else { 
__p+=' '+
((__t=( ctaButtonName ))==null?'':__t)+
' ';
 } 
__p+='</span></div>\n              </a>\n            ';
 } 
__p+='\n          ';
 } else { 
__p+='\n            <a href="javascript:void(0);" class="js-hide-ajax-fail ';
 if (!MOVE.Helper.isMobile()) { 
__p+=' round-cta ';
 } 
__p+=' email-button ';
 if (leadSubmitted) { 
__p+=' contacted ';
 } else { 
__p+=' js-qv-contact-agent ';
 } 
__p+='" ';
 if (!leadSubmitted) { 
__p+=' data-omtag="ldp:quickview:stickyfooter:contact-agent" data-formid="secondary" ';
 } 
__p+=' sticky-contact-agent>\n                ';
 if (leadSubmitted) { 
__p+=' Contacted ';
 } else { 
__p+=' '+
((__t=( ctaButtonName ))==null?'':__t)+
' ';
 } 
__p+='\n            </a>\n          ';
 } 
__p+='\n        ';
 } 
__p+='\n      ';
 } 
__p+='\n    ';
 } 
__p+='\n    ';
 } 
__p+='\n    ';
 if (!isLeadFormSuppressed && (!isLdpLeadsTextEnabled || !isCoBroke)) { 
__p+='\n      ';
 if (MOVE.Helper.isMobile() && !isNewPlan) { 
__p+='\n        ';
 if (hasSuppressLeadForm) { 
__p+='\n          <a href="javascript:void(0);" id = "footer-email-btn" class="js-hide-ajax-fail email-contruction-class ';
 if (leadSubmitted)  { 
__p+=' contacted-btn ';
 } 
__p+=' ';
 if (!MOVE.Helper.isMobile()) { 
__p+=' round-cta ';
 } 
__p+=' email-button ';
 if (leadSubmitted) { 
__p+=' contacted ';
 } else { 
__p+=' js-qv-contact-agent ';
 } 
__p+='" ';
 if (!leadSubmitted) { 
__p+=' data-omtag="ldp:quickview:stickyfooter:contact-agent" data-formid="secondary" ';
 } 
__p+=' sticky-contact-agent>\n            <div class="icon-container"><span class="';
 if (!leadSubmitted && !isNewPlan) { 
__p+=' email-icon-mobile ';
 } 
__p+='"></span><span class="';
 if (!leadSubmitted) { 
__p+=' ab-email-words ';
 } 
__p+='">';
 if (leadSubmitted) { 
__p+=' Contacted ';
 } else { if (ctaText == 'V1' && ctaButtonName == 'Contact Agent'){
__p+=' Contact an Agent ';
 } else {
__p+=' '+
((__t=( ctaButtonName ))==null?'':__t)+
' ';
}} 
__p+='</span></div>\n          </a>\n        ';
 } else { 
__p+='\n          <a href="javascript:void(0);" data-target="#textInputModal" data-toggle="modal" data-lead-position="qv-footer" class="btn suppress-lead-form-text" id="qv-sticky-text-cta" data-omtag="ldp:persistant-footer:text-agent">Text</a>\n        ';
 } 
__p+='\n      ';
 } else { 
__p+='\n        ';
 if (hasSuppressLeadForm) { 
__p+='\n          <a href="javascript:void(0);" id = "footer-email-btn" class="js-hide-ajax-fail email-contruction-class-alt ';
 if (leadSubmitted)  { 
__p+=' contacted-btn ';
 } 
__p+=' ';
 if (!MOVE.Helper.isMobile()) { 
__p+=' round-cta ';
 } 
__p+=' email-button ';
 if (leadSubmitted) { 
__p+=' contacted ';
 } else { 
__p+=' js-qv-contact-agent ';
 } 
__p+='" ';
 if (!leadSubmitted) { 
__p+=' data-omtag="ldp:quickview:stickyfooter:contact-agent" data-title="'+
((__t=( title ))==null?'':__t)+
'" data-placeholder="'+
((__t=( placeholder ))==null?'':__t)+
'" data-formid="secondary" ';
 } 
__p+=' sticky-contact-agent>\n            ';
 if (leadSubmitted) { 
__p+=' Contacted ';
 } else { if (ctaText == 'V1' && ctaButtonName == 'Contact Agent'){
__p+=' Contact an Agent ';
 } else {
__p+=' '+
((__t=( ctaButtonName ))==null?'':__t)+
' ';
}} 
__p+='  </a>\n          </a>\n        ';
 } else { 
__p+='\n          <a href="javascript:void(0);" data-target="#textInputModal" data-toggle="modal" data-lead-position="qv-footer" class="btn suppress-lead-form-text" id="qv-sticky-text-cta" data-omtag="ldp:persistant-footer:text-agent">Text</a>\n        ';
 } 
__p+='\n      ';
 } 
__p+='\n  ';
 } 
__p+='\n';
 } 
__p+='\n';
return __p;
};



// WEBPACK FOOTER //
// ./quick_view/templates/qv-footer.jst.ejs